module.exports = __webpack_public_path__ + "img/vya.9e637f9f.png";